/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "368")




  export type API59162Req = {};



export interface API59162Res {
  /** 周期编号  */
  periodNo?: string;
  /** 周期名称  */
  periodName?: string;
  /** obj数量  */
  objCount?: number;
  /** kr数量  */
  krCount?: number;
  /** 总进度，例如30%返回3000  */
  progressNumber?: number;
  /** 审核状态  */
  auditStatus?: number;
  /** 审核状态-中文  */
  auditStatusStr?: string;
  /** 周期开始时间  */
  periodStartDate?: any;
  
};


// 59162 我的okr

export interface IUseGetAPI59162Return {
  /** 我的okr: 接口请求状态 */
  isAPI59162Loading: boolean;
  /** 我的okr: 接口请求返回数据 */
  dataAPI59162: API59162Res;
  /**  我的okr: 接口数据请求方法 */
  fetchAPI59162Data:  ( config?: YWRequestConfig) => Promise<API59162Res>;
  /** 我的okr: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI59162 = ():IUseGetAPI59162Return => {
  let isMount = true;
  const [isAPI59162Loading, setIsAPI59162Loading] = useState(false);
  const [dataAPI59162, setDataAPI59162] = useState<API59162Res>({} as API59162Res);
  const requestUrl = `${basePath}/internal-control-biz/admin/okr/my`;

  const fetchAPI59162Data = async ( config?: YWRequestConfig): Promise<API59162Res> => {
  
    if ( isMount ) {
      setIsAPI59162Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API59162Res>(`${basePath}/internal-control-biz/admin/okr/my`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI59162(res || {} as API59162Res);
        setIsAPI59162Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI59162Loading(false);
      }
      return false as unknown as API59162Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI59162Loading,
    dataAPI59162,
    fetchAPI59162Data,
    requestUrl,
  }
}

